import React from "react";
import Styled from "./styles";
import Table from "../../Table";

const PNDSLookup = ({ lastUpdatedDate, noDataMessage }) => {
  const columns1 = [{ name: "providerNetwork", label: "PNDS Provider Network " }];

  const providerNetworkData = [
    {
      providerNetwork: "https://pndslookup.health.ny.gov",
    },
  ];

  return (
    <Styled>
      {providerNetworkData && providerNetworkData.length > 0 ? (
        <Table
          columns={columns1}
          data={providerNetworkData.map((hp) => ({
            ...hp,
            providerNetwork: (
              <a
                className="provider-network-link"
                href={hp.providerNetwork}
                target="_blank"
                rel="noopener noreferrer"
              >
                {hp.providerNetwork}
              </a>
            ),
          }))}
        />
      ) : (
        <p className="no-content">
          {noDataMessage ? noDataMessage : "None reported"}
        </p>
      )}
    </Styled>
  );
};

export default PNDSLookup;
